// removed by extract-text-webpack-plugin
module.exports = {"row":"FAQs-row-c1d03f3c","col":"FAQs-col-9ca0baa9","button":"FAQs-button-06c61d65","bannerAd":"FAQs-bannerAd-5062e7d8","rail":"FAQs-rail-2dd1a1fc","FAQsHeading":"FAQs-FAQsHeading-65adcfa2","FAQMainConatiner":"FAQs-FAQMainConatiner-8a1fc8ef","FAQContainer":"FAQs-FAQContainer-81c88a8a","FAQ":"FAQs-FAQ-62b2830c","FAQCol1":"FAQs-FAQCol1-3e4847d6","FAQCol2":"FAQs-FAQCol2-77ea0055","FAQSingleCol":"FAQs-FAQSingleCol-642b4cb3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FAQs/FAQs.scss
// module id = 855
// module chunks = 0